import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Grid,
  Paper,
  Stack,
  useTheme,
} from "@mui/material";
import { Palette, ViewQuilt, Menu, Save } from "@mui/icons-material";
import { IRaffle } from "../../../store/interfaces/IRaffle";
import { DeviceFrameset } from "react-device-frameset";
import { PreviewRaffle2 } from "../../home/PreviewRaffle2";

interface CustomizationsProps {
  raffle: IRaffle;
}

export const Customizations = ({ raffle }: CustomizationsProps) => {
  const theme = useTheme();
  const showPremiumAlert = true;

  const [primaryColor, setPrimaryColor] = useState("#000000");
  const [secondaryColor, setSecondaryColor] = useState("#FF0000");
  const [menuPosition, setMenuPosition] = useState("top");
  const [templateName, setTemplateName] = useState("clásico");

  const handleSave = () => {
    console.log("🚀 Guardando configuración personalizada:", {
      primaryColor,
      secondaryColor,
      menuPosition,
      templateName,
    });
  };

  return (
    <Card
      sx={{
        mx: "auto",
        p: 3,
        borderRadius: 3,
        boxShadow: 4,
        maxWidth: 900,
        maxHeight: 600,
        textAlign: "center",
      }}
    >
      <CardContent
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "400px",
          overflow: "hidden",
        }}
      >
        {showPremiumAlert && (
          <>
            {/* Overlay Blur */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backdropFilter: "blur(2px)",
                zIndex: 1,
              }}
            />
            {/* Alert Message */}
            <Box
              sx={{
                position: "absolute",
                top: "20%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 12,
                backgroundColor: "black",
                border: `2px solid white`,
                borderRadius: 2,
                padding: 4,
                boxShadow: 6,
                textAlign: "center",
                maxWidth: 420,
              }}
            >
              <Typography variant="h6" color="warning.main" gutterBottom>
                🎨 Personalización avanzada (en desarrollo)
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Este módulo permite <strong>personalizar visualmente tu rifa</strong> como nunca antes:
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={2}>
                Podrás editar los <strong>colores del sitio</strong>, la <strong>posición del menú</strong>, elegir entre <strong>templates visuales</strong> por defecto o crear <strong>plantillas personalizadas</strong> para tu marca.
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={2} fontWeight="bold">
                Lanzamiento estimado: <span style={{ color: theme.palette.warning.main }}>15 de septiembre</span>
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                Disponible solo para rifas con plan Premium.
              </Typography>
            </Box>

          </>
        )}

        <Typography variant="h5" color="primary" gutterBottom>
          🎨 Personalización avanzada
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
          Personaliza colores, menú y elige tu diseño visual para hacer que tu rifa luzca como tu marca.
        </Typography>

        <Paper sx={{ p: 3, width: "100%", maxWidth: 700 }}>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6}>
                <TextField
                  fullWidth
                  label="Color primario"
                  type="color"
                  value={primaryColor}
                  onChange={(e) => setPrimaryColor(e.target.value)}
                  InputProps={{ startAdornment: <Palette sx={{ mr: 1 }} /> }}
                />
              </Grid>
              <Grid item xs={6} sm={6}>
                <TextField
                  fullWidth
                  label="Color secundario"
                  type="color"
                  value={secondaryColor}
                  onChange={(e) => setSecondaryColor(e.target.value)}
                  InputProps={{ startAdornment: <Palette sx={{ mr: 1 }} /> }}
                />
              </Grid>
              <Grid item xs={6} sm={6}>
                <TextField
                  fullWidth
                  label="Posición del menú"
                  value={menuPosition}
                  onChange={(e) => setMenuPosition(e.target.value)}
                  placeholder="top | left | right"
                  InputProps={{ startAdornment: <Menu sx={{ mr: 1 }} /> }}
                />
              </Grid>
              <Grid item xs={6} sm={6}>
                <TextField
                  fullWidth
                  label="Nombre del template"
                  value={templateName}
                  onChange={(e) => setTemplateName(e.target.value)}
                  placeholder="clásico | moderno | personalizado"
                  InputProps={{ startAdornment: <ViewQuilt sx={{ mr: 1 }} /> }}
                />
              </Grid>  
              </Grid>
            </Grid>
            <Grid item xs={6} sm={6}>
              <Box sx={{ transform: "scale(0.50) !important", transformOrigin: "top left", paddingX: 10 }}>
                  <DeviceFrameset
                    device="iPhone X"
                  >
                    <div style={{ height: '820px', overflowY: 'scroll' }}>
                      <PreviewRaffle2 activeRaffle={raffle as any} />
                    </div>
                  </DeviceFrameset>
              </Box>
            </Grid>
          </Grid>
          <Button
            onClick={handleSave}
            variant="contained"
            color="primary"
            startIcon={<Save />}
            sx={{ mt: 3 }}
            disabled={!raffle.isPremium}
          >
            Guardar configuración
          </Button>
        </Paper>
      </CardContent>
    </Card>
  );
};
